export default __webpack_public_path__ + "static/media/hfp3.7d450bfd.jpg";